import { render, staticRenderFns } from "./WrapComponents.vue?vue&type=template&id=18eca3ae"
var script = {}
import style0 from "./WrapComponents.vue?vue&type=style&index=0&id=18eca3ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports